"use client";
import { Icon, RadioButton, Tooltip, Typography } from "@kyan/ui";

import { MIN_RFQ_SIZE, rfqDurations } from "#/config/orders";
import { useOptionSize } from "#/store/options/tradePanel/optionSize";
import { useRfqRequestDuration } from "#/store/rfq/rfqRequestDuration";

import { FocusableSizeInput } from "../../../../../../../FocusableSizeInput/FocusableSizeInput";

export const OptionRFQ: React.FC = () => {
  const { setOptionSize, optionSize } = useOptionSize();
  const { rfqRequestDuration, setRfqRequestDuration } = useRfqRequestDuration();

  return (
    <div className="mb-3 grid gap-1">
      <div className="mt-2 mb-1 flex items-center">
        <Typography xs grotesk className="flex w-1/3 items-center gap-1">
          Duration
          <Tooltip content="Response window for Market Makers.">
            <Icon size="xs" name="question" className="text-textSecondary" />
          </Tooltip>
        </Typography>

        <RadioButton
          size="md"
          className="flex-1"
          variant="secondary"
          value={rfqRequestDuration}
          items={rfqDurations.map((duration) => ({
            id: duration,
            label: `${duration} min`,
            className: "flex-1",
          }))}
          onChange={setRfqRequestDuration}
        />
      </div>
      <FocusableSizeInput
        inputProps={{
          rightIcon: "Qty",
          value: optionSize,
          label: "Size in contracts",
          onChange: setOptionSize,
          wrapperClassName: "mb-1",
        }}
      />
      <Typography xs grotesk>
        Min. size: {MIN_RFQ_SIZE} contracts
      </Typography>
    </div>
  );
};
